module.exports = {"210112007":"英达街道","210112009":"东湖街道","210112010":"五三街道","210112012":"浑河站东街道","210112014":"高坎街道","210112015":"满堂街道","210112016":"深井子街道","210112017":"祝家街道","210112018":"白塔街道","210112019":"桃仙街道","210112020":"李相街道","210112021":"营城子街道","210112022":"汪家街道","210112023":"王滨街道","210112024":"望滨街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210112.json
// module id = 458
// module chunks = 0